import { useEffect } from "react"


const Notfound = () => {

    return (
        <div className="pageCont" style={{'height':'60vh'}}>
            <h1>notFound</h1>
        </div>
    );
}
 
export default Notfound;